<template>
  <div>
    <b-row>
      <b-col
        md="12"
        class="justify-content-center"
        :key="i"
        v-for="(kyc, i) in localKycDocuments"
      >
        <b-row>
          <h5 class="h5-text p-1 m-0">
            {{ kyc.docType }} :
            <span class="span-text">{{ kyc.docuementNo }}</span>
          </h5>
        </b-row>
        <b-row>
          <h5 class="h5-text p-1 m-0">
            Document Type :
            <span class="span-text">{{ kyc.docType }}</span>
          </h5>
        </b-row>
        <b-row>
          <h5 class="h5-text p-1 m-0">Photo :</h5>
        </b-row>
        <b-row>
          <b-col md="6">
      <image-uploader
  :value="kyc.frontSideFilePath"
  @change="(d) => uploadImage('frontSideFilePath', d, i)"
  :id="`photo-front-${i}`"
  text="Upload Front Side"
/>
           
            <label>Front Side</label>
          </b-col>
          <b-col md="6">
      <image-uploader
  :value="kyc.backSideFilePath"
  @change="(d) => uploadImage('backSideFilePath', d, i)"
  :id="`photo-back-${i}`"
  text="Upload Back Side"
/>
           
            <label>Back Side</label>
          </b-col>
        </b-row>
        <hr />
      </b-col>
    </b-row>
  </div>
</template>
 
<script>
import Vue from "vue";
import ImageUploader from "../../components/FormElements/image.vue";
export default {
  props: {
    kycDocuments: {
      type: [Array, Object],
    },
  },
  data() {
        return {
            localKycDocuments: [],
            currentKycIndex: -1,
        };
    },
    watch: {
        kycDocuments: {
            immediate: true,
            handler(newVal) {
                this.localKycDocuments = JSON.parse(JSON.stringify(newVal || []));
            }
        }
    },
  components: {
        ImageUploader,
    },
    methods: {
        clearCustomToast() {
            Vue.toasted.clear();
        },
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },
    async uploadImage(path, image, index) {
  const currentDoc = this.localKycDocuments[index]; // ✅ Get the correct document from local array
 
  let dataobj = {
    image: image,
    key: (
      Date.now().toString(36) +
      Math.random().toString(36).substr(2, 5)
    ).toLowerCase(),
    isPublic: true,
    replaceExisting: true,
    basePath: ["kyc", "agent"],
  };
 
  this.showCustomToast();
 
  try {
    const res = await this.$store.dispatch("inventory/uploadImageToStorage", dataobj);
    this.clearCustomToast();
 
    const updatedDoc = {
      ...currentDoc,
      [path]: res.data.fileUrl,
      docId: currentDoc._id || currentDoc.id,
    };
 
    // ✅ Update the local array reactively
    this.$set(this.localKycDocuments, index, updatedDoc);
 
    this.$emit("updateKYC", updatedDoc);
  } catch (error) {
    this.clearCustomToast();
    this.$toasted.error("Image not uploaded..please try again!");
  }
}
 
      }
};
</script>
<style scoped>
  .border-img-doc {
    border: 2px solid #ececec;
    border-radius: 5px;
  }
</style>
 
 